import { z } from 'zod';
import { emailBodyValidation, emailSubjectValidation } from '../../validations/sharedEmailValidations';

export const optInEmailFormSchema = z.object({
    subject: emailSubjectValidation,
    body: emailBodyValidation,
});

export type OptInEmailFormData = z.infer<typeof optInEmailFormSchema>;
